import { Injectable } from '@angular/core';
import { FlowTypes, YesNoEmpty } from '@interfaces/models';
import { Store } from '@ngrx/store';
import * as fromRootStore from '@store/index';
import { selectTriageState } from '@store/index';
import { TriageState } from '@store/reducers/triage/triage.reducer';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, switchMap } from 'rxjs';

@Injectable()
export class TriageGuard {
  constructor(
    private globalStore: Store<fromRootStore.State>,
    private cookieService: CookieService,
  ) {}

  canActivate(): Observable<boolean> {
    if (this.cookieService.get('routeGuard') === 'OFF') {
      return of(true);
    }

    return this.isTrusteeOrEstate();
  }

  isTrusteeOrEstate(): Observable<boolean> {
    return this.globalStore.select(selectTriageState).pipe(
      switchMap((triage: TriageState) => {
        return of(
          triage.flowType === FlowTypes.MULTI_INHERITANCE &&
            (triage.isClient === 'YES' || triage.isClient === 'NO') &&
            triage.isTrusteeOrEstate === YesNoEmpty.YES &&
            triage.isInheritingMultipleAccounts === YesNoEmpty.EMPTY,
        );
      }),
    );
  }
}
